export const hasRecoverableSession = sessionData => {
  const { encAuthnIdentifier, encCredential, encData } = sessionData || {};

  return Boolean(encAuthnIdentifier && encCredential && encData);
};

export const shouldRecoverSession = ({
  allowSessionRecovery,
  error,
  sessionData,
}) =>
  allowSessionRecovery &&
  error?.payload?.errorMsg?.statusCode === 401 &&
  hasRecoverableSession(sessionData);
